// require('./index.scss');

class Module {
  constructor() {
    this.init;
  }
  AppendGameList(arr, callback) {
    const result = arr.map((v, index) => {
      return this.createGameList(v);
    });
    callback ? callback(result.join('')) : '';
  }

  createGameList(obj) {
    return `<div class="m-gamelist-item" data-statis="logo_hotword_playlist_po_${obj.num}}" type="btn" href="${obj.url}">
  <div class="m-gamelist-item-container">
    <div class="m-gamelist-item-bg">
    <img class="lazy" dataimg="${obj.img}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif" />
    </div>
    <div class="m-gamelist-item-like">${obj.like}</div>
    <div class="m-gamelist-item-title">${obj.abstract}</div>
  </div>
  <div class="m-gamelist-item-userinfo">
    <div class="m-gamelist-item-userinfo-headicon">
     <img class="lazy" dataimg="${obj.userIcon}" src="https://image.9game.cn/s/uae/g/1m/ngp_portal_mobile/page/homesite/index/images/lazy_d9f097f.gif" >
    </div>
    <div class="m-gamelist-item-userinfo-detail">
      <div class="m-gamelist-item-userinfo-detail-name">${obj.userName}</div>
      <div class="m-gamelist-item-userinfo-detail-level">
        <div class="m-gamelist-item-userinfo-detail-level-level ${obj.userLevel}"></div>
        <div class="m-gamelist-item-userinfo-detail-level-abstract">${obj.userAbstract}</div>
      </div>
    </div>
  </div>
</div>`;
  }
}

module.exports = new Module();


// WEBPACK FOOTER //
// ./jws/views/page/hotwords/module/game-list/index.js